import { gaRoutes } from './synergyAdapterGA';
import { GA4RouteType } from './types';

export const getRoute = (url?: string): GA4RouteType => {
  return url ? gaRoutes[url] ?? { page_name: url } : { page_name: '' };
};
